"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Body = void 0;
var styled_components_1 = __importDefault(require("styled-components"));
exports.Body = styled_components_1.default.p.attrs({
    className: "Body",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1.5;\n  ", "\n  ", "\n    ", "\n  i {\n    color: var(--concrete);\n  }\n"], ["\n  color: ", ";\n  font-size: ", ";\n  font-weight: ", ";\n  line-height: 1.5;\n  ", "\n  ", "\n    ", "\n  i {\n    color: var(--concrete);\n  }\n"])), function (props) {
    return (props.color && "var(--" + props.color + ")") || "var(--black)";
}, function (props) {
    return (props.size && "var(--font-size-" + props.size + ")") ||
        "var(--font-size-m)";
}, function (props) {
    return (props.weight && "var(--font-weight-" + props.weight + ");") ||
        "var(--font-weight-regular)";
}, function (props) {
    return props.withoutMargins
        ? "\n      margin: 0;\n    "
        : "\n      margin-top: ".concat((props.size && "calc(var(--font-size-" + props.size + ") / 1.125)") ||
            "calc(var(--font-size-m) / 1.125)", ";\n      margin-bottom: ").concat((props.size && "calc(var(--font-size-" + props.size + ") * 0.25)") ||
            "calc(var(--font-size-m) * 0.25)", ";\n    ");
}, function (props) {
    return props.multiline &&
        "\n      white-space: pre-wrap;\n    ";
}, function (props) {
    return props.flex &&
        "\n      display: flex; \n      align-items: center;\n      ";
});
var templateObject_1;
